<script setup lang="ts">
import WelcomeCard from "@/components/dashboards/dashboard1/WelcomeCard.vue";
import WelcomeCompanyCard from "@/components/dashboards/dashboard1/WelcomeCompanyCard.vue";
import loggerLocal from "@/utils/loggerLocal";

import { QuoteListForm } from "@/utils/asyncLoading";
import { DBQuoteType } from "@functions/models/DBEnum";
import { onMounted } from "vue";

onMounted(() => loggerLocal.info("[dashboard] mounted"));
</script>
<template>
  <!-- Loader -->
  <!--<SnackBar />-->
  <!-- Loader -->

  <v-row>
    <!-- Welcome Cards -->
    <v-row>
      <v-col cols="12" md="6">
        <WelcomeCard />
      </v-col>
      <v-col cols="12" md="6" class="hidden-sm-and-down">
        <WelcomeCompanyCard />
      </v-col>

      <v-col cols="12">
        <QuoteListForm
          :showActionMenu="false"
          :showSearch="false"
          :refreshToken="new Date().toISOString()"
          :quoteType="DBQuoteType.ORDER"
          :showPagination="false"
          :showSeeOther="true"
        />
      </v-col>
    </v-row>

    <!--<v-col cols="12" lg="5">
      <v-row>
        <v-col cols="12" md="6">
          <CustomerCard />
        </v-col>
        <v-col cols="12" md="6">
          <ProjectCard />
        </v-col>
      </v-row>
    </v-col>
    
    <v-col cols="12" lg="7">
      <RevenueForcast />
    </v-col>

    
    <v-col cols="12" lg="5">
      <Performence />
    </v-col>
    
    <v-col cols="12" lg="7">
      <v-row>
        <v-col cols="12" md="6">
          <CustomerChart />
        </v-col>
        <v-col cols="12" md="6">
          <SalesOverview />
        </v-col>
      </v-row>
    </v-col>
    
    <v-col cols="12" lg="8">
      <RevenueProducts />
    </v-col>
    <v-col cols="12" lg="4">
      <TotalSettelment />
    </v-col>-->
  </v-row>
</template>
